import { GA_PAGE_TYPE } from '@/lib/ga/constants/datalayer'

const pageTypeMapping: Record<string, string> = {
  [GA_PAGE_TYPE.ZERO_SEARCH_RESULTS_PAGE]: 'zsp',
  [GA_PAGE_TYPE.SEARCH_AD]: 'srl',
  [GA_PAGE_TYPE.BROWSE_AD]: 'brl',
  [GA_PAGE_TYPE.VIEW_AD]: 'vip',
}

/**
 * Converts an internal page type name to its corresponding Adsense tracking page type code.
 * If the internal page type name is not found in the mapping, an empty string is returned.
 *
 * @param {GA_PAGE_TYPE} pageTypeName - The internal page type name.
 * @returns {string} The corresponding Adsense tracking page type code.
 *
 * @example
 *  determinePageType(GA_PAGE_TYPE.SEARCH_AD) // Returns: 'srpl'
 *  determinePageType(GA_PAGE_TYPE.VIEW_AD) // Returns: 'vip'
 *  determinePageType('SOME_UNKNOWN_PAGE_TYPE') // Returns: 'o'
 */
export function determinePageType(pageTypeName: string): string {
  return pageTypeMapping[pageTypeName] || 'o'
}
